import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { DatePipe, TitleCasePipe } from '@angular/common';

import { Subject } from 'rxjs';

import { SettingsService } from 'src/app/services/settings/settings.service';
import { BrandService } from 'src/app/shared/services/brand/brand.service';

import { L10nPipe } from 'src/app/helpers/pipes/L10n.pipe';

import { BRAND_FOOTER_LINKS, Brands } from 'src/app/shared/constants/brands.constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [L10nPipe, DatePipe, TitleCasePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit, OnDestroy {
  links: { label: string; route: string }[];
  year = new Date();
  brand = Brands.REGUS;

  private readonly destroyed$: Subject<void> = new Subject<void>();

  constructor(
    private readonly settings: SettingsService,
    private readonly brandService: BrandService
  ) {}

  ngOnInit(): void {
    this.brand = this.brandService.getCurrentBrand();
    const linksUnmapped = Object.entries(BRAND_FOOTER_LINKS);
    this.links = linksUnmapped.map(([route, label]) => ({
      route: this.settings.formLink(route),
      label
    }));
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
